import { useQuery } from "react-query";
import { WPPost } from "../../../../constants/types";
import { ListingAcf } from "../../../../constants/types/acf";
import { useBaseUrl } from "../../../../services/app-state";
import { fetchJSON } from "../../../../utils/ajax";
import { listingDataCache } from "../controller";

export const useListingData = (listingSlug: string) => {
    const baseUrl = useBaseUrl();

    return useQuery(["listing", listingSlug], {
        queryFn: () =>
            fetchJSON<WPPost<ListingAcf>>(
                `${baseUrl}/wp-json/headstart/v1/listing?path=${listingSlug}`,
            ),
        initialData: listingDataCache[listingSlug],
    });
};
